module.exports = __webpack_public_path__ + "static/img/caih-login-bg.3b364d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caih-login-bg.png
// module id = pH2W
// module chunks = 1